module.exports = __webpack_public_path__ + "static/NudistaLight-Italic-e3455a36e67b6cec34f8811b7b6e466b.ttf";